import script from "./MockupPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./MockupPhone.vue?vue&type=script&setup=true&lang=js"

import "./MockupPhone.vue?vue&type=style&index=0&id=391953f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391953f0"]])

export default __exports__